import { adminRoutes } from './admin';
import { portalRoutes } from './portal';
import { retailerRoutes } from './retailer';
import {employeeRoutes} from "./employee";
import { crossPortalRoutes } from './cross-portal-routes';

export const routes = [
	...crossPortalRoutes,
	...portalRoutes,
	...adminRoutes,
	...retailerRoutes,
	...employeeRoutes,
];
